import { useRef } from 'react';

const DRAG_THRESHOLD = 5;

const useHorizontalDrag = ({
  onMoveStart,
  onMove,
  threshold = DRAG_THRESHOLD
}) => {
  const startDragPosition = useRef(null);
  const scrollLeftStart = useRef(null);
  const hasDragged = useRef(false);
  const containerRef = useRef(null);

  const handleMouseMove = e => {
    const currentPosition = e.pageX;
    const delta = currentPosition - startDragPosition.current;
    // Check if user actually dragged beyond threshold
    if (Math.abs(delta) > threshold) {
      if (!hasDragged.current) {
        hasDragged.current = true;
        onMoveStart();
      }
      containerRef.current.scrollLeft = scrollLeftStart.current - delta;
      onMove();
    }
  };

  const handleMouseDown = e => {
    startDragPosition.current = e.pageX;
    scrollLeftStart.current = containerRef.current.scrollLeft;
    hasDragged.current = false;
    containerRef.current.style.cursor = 'grabbing';

    // eslint-disable-next-line no-use-before-define
    document.addEventListener('mouseup', handleMouseUp);
    document.addEventListener('mousemove', handleMouseMove);
    handleMouseMove(e);
  };

  const handleMouseUp = () => {
    if (containerRef.current) {
      containerRef.current.style.cursor = 'grab';
    }

    document.removeEventListener('mouseup', handleMouseUp);
    document.removeEventListener('mousemove', handleMouseMove);

    // Reset the drag flag after a short delay to allow click prevention
    setTimeout(() => {
      hasDragged.current = false;
    }, 100);
  };

  return {
    isDragging: () => hasDragged.current,
    containerRef,
    handleMouseDown,
    handleMouseUp,
    handleMouseMove
  };
};

export default useHorizontalDrag;
